import { cn } from "@/lib/utils";

/**
 * Reusable avatar primitive. Renders an `<img>` when `src` is
 * truthy, falls back to initials in a primary-coloured circle.
 * Used by `SidebarUserMenu` for the bottom-of-sidebar block, and
 * available anywhere in the app that needs to render the operator's
 * face.
 */
export function UserAvatar({
  src,
  fallback,
  size = "md",
  className,
}: {
  src: string | null | undefined;
  fallback: string; // initials or single letter
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const dim =
    size === "lg" ? "h-12 w-12 text-base" : size === "sm" ? "h-6 w-6 text-[10px]" : "h-8 w-8 text-xs";
  const base =
    "shrink-0 rounded-full inline-flex items-center justify-center overflow-hidden";

  if (src) {
    return (
      <span className={cn(base, dim, "bg-muted", className)}>
        <img
          src={src}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </span>
    );
  }

  return (
    <span
      className={cn(
        base,
        dim,
        "bg-primary text-primary-foreground font-medium",
        className,
      )}
    >
      {fallback || "—"}
    </span>
  );
}
